import { Size } from "@repo/ui/helpers/helpers";
import { entityTable } from "@repo/ui/tables/entityTable";
import type { FC, ReactNode } from "react";

export interface SettingsTableHeaderSectionProps {
  children: ReactNode;
}

export const SettingsTableHeaderSection: FC<SettingsTableHeaderSectionProps> = (
  props,
) => (
  <thead className={entityTable({ size: Size.SMALL }).header()}>
    {props.children}
  </thead>
);
